import React from "react"

function ContentH() {
  return (
    <svg viewBox="0 0 266 150" fill="none">
      <path fill="var(--solid)" d="M0 0h266v150H0z" />
      <path
        d="M20 111.5a1.5 1.5 0 011.5-1.5h64a1.5 1.5 0 010 3h-64a1.5 1.5 0 01-1.5-1.5zM20 118.5a1.5 1.5 0 011.5-1.5h51a1.5 1.5 0 010 3h-51a1.5 1.5 0 01-1.5-1.5z"
        fill="var(--base-500)"
      />
      <path
        d="M20 125.5a1.5 1.5 0 011.5-1.5h18a1.5 1.5 0 010 3h-18a1.5 1.5 0 01-1.5-1.5z"
        fill="var(--main-500)"
      />
      <path
        d="M45.444 87h17.112A2.444 2.444 0 0065 84.556V67.444A2.444 2.444 0 0062.556 65H45.444A2.444 2.444 0 0043 67.444v17.112A2.444 2.444 0 0045.444 87zm0 0L58.89 73.556l6.11 6.11m-13.444-7.944a1.833 1.833 0 11-3.667 0 1.833 1.833 0 013.667 0z"
        stroke="var(--base-500)"
        strokeWidth={1.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x={20}
        y={101}
        width={56}
        height={4}
        rx={2}
        fill="var(--solid-900)"
      />
      <path
        d="M100 111.5a1.5 1.5 0 011.5-1.5h64a1.5 1.5 0 010 3h-64a1.5 1.5 0 01-1.5-1.5zM100 118.5a1.5 1.5 0 011.5-1.5h51a1.5 1.5 0 010 3h-51a1.5 1.5 0 01-1.5-1.5z"
        fill="var(--base-500)"
      />
      <path
        d="M100 125.5a1.5 1.5 0 011.5-1.5h18a1.5 1.5 0 010 3h-18a1.5 1.5 0 01-1.5-1.5z"
        fill="var(--main-500)"
      />
      <path
        d="M125.444 87h17.112A2.444 2.444 0 00145 84.556V67.444A2.444 2.444 0 00142.556 65h-17.112A2.444 2.444 0 00123 67.444v17.112A2.444 2.444 0 00125.444 87zm0 0l13.445-13.444 6.111 6.11m-13.444-7.944a1.834 1.834 0 11-3.667 0 1.834 1.834 0 013.667 0z"
        stroke="var(--base-500)"
        strokeWidth={1.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x={100}
        y={101}
        width={56}
        height={4}
        rx={2}
        fill="var(--solid-900)"
      />
      <path
        d="M180 111.5a1.5 1.5 0 011.5-1.5h64a1.5 1.5 0 010 3h-64a1.5 1.5 0 01-1.5-1.5zM180 118.5a1.5 1.5 0 011.5-1.5h51a1.5 1.5 0 010 3h-51a1.5 1.5 0 01-1.5-1.5z"
        fill="var(--base-500)"
      />
      <path
        d="M180 125.5a1.5 1.5 0 011.5-1.5h18a1.5 1.5 0 010 3h-18a1.5 1.5 0 01-1.5-1.5z"
        fill="var(--main-500)"
      />
      <path
        d="M205.444 87h17.112A2.444 2.444 0 00225 84.556V67.444A2.444 2.444 0 00222.556 65h-17.112A2.444 2.444 0 00203 67.444v17.112A2.444 2.444 0 00205.444 87zm0 0l13.445-13.444 6.111 6.11m-13.444-7.944a1.834 1.834 0 11-3.667 0 1.834 1.834 0 013.667 0z"
        stroke="var(--base-500)"
        strokeWidth={1.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x={180}
        y={101}
        width={56}
        height={4}
        rx={2}
        fill="var(--solid-900)"
      />
      <rect
        x={142}
        y={23}
        width={104.391}
        height={4}
        rx={2}
        fill="var(--base-500)"
      />
      <rect
        x={20}
        y={23}
        width={74}
        height={5}
        rx={2.5}
        fill="var(--solid-900)"
      />
      <rect
        x={142}
        y={31}
        width={77}
        height={4}
        rx={2}
        fill="var(--base-500)"
      />
    </svg>
  )
}

export default ContentH;
